import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateSuspectDialog } from "./CreateSuspect";

const CreateSuspectUrlHandler: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  // Handle dialog close
  const handleClose = () => {
    setIsOpen(false);

    // Determine where to navigate on close
    // If we came from a specific background route, go back to it
    const background = location.state?.background;
    if (background) {
      navigate(-1);
    } else {
      // Otherwise, go to the base path
      navigate(-1);
    }
  };

  return <CreateSuspectDialog open={isOpen} onClose={handleClose} />;
};

export default CreateSuspectUrlHandler;
